import React, {useState, useCallback, useEffect} from 'react'
import {store} from '../../stores/store'
import { observer } from 'mobx-react';

import Marker from './Marker'
import Overlay from './Overlay'
import MarkersPool from '../../js/MarkersPool';
import PopupStore from '../../stores/PopupStore';


let originW = 2048
let originH = 1536


function calculateDimensions(node) {
  const w = node.offsetWidth
  const h = node.offsetHeight
  const ratio = w/h
  const mode = (ratio < originW/originH) ? "contain" : "cover"
  const scale = originW / w
  const imgH = originH / scale

  const offsetTop = mode === "cover" ? 0 : (h - imgH) / 2;
  const offsetLeft = 0
  return { offsetTop, offsetLeft, scale, mode }
}

const overlays = [
  { id: "vaches1", file: "Vaches1.png", x: 956, y: 149, visible: ["A.6.5", "A.6.6", "A.6.7", "A.6.8", "A.6.9", "A.6.11"] },
  { id: "vaches2", file: "Vaches2.png", x: 174, y: 948, visible: ["A.6.5", "A.6.6", "A.6.7", "A.6.8", "A.6.9", "A.6.11"] },
  { id: "agroforesterie02", file: "Agroforesterie02.png", x: 1079, y: 0, visible: ["C.15.2"] },
  { id: "agroforesterie01", file: "Agroforesterie01.png", x: 951, y: 44, visible: ["C.15.2"] },
  { id: "fosselisier", file: "FosseLisier.png", x: 1256, y: 801, visible: ["A.4.3", "A.4.5"] },
  { id: "fumiere", file: "Fumiere.png", x: 1247, y: 810, visible: ["A.4.1", "A.4.2", "A.4.4"] },
  { id: "haies", file: "Haies.png", x: 714, y: 65, visible: ["C.14.4"] },
  { id: "riviereboueuse", file: "RiviereBoueuse.png", x: 0, y: 709, visible: (indsPool) =>{ return indsPool.getIndicatorValue("indT21") < 0.5 }},
  { id: "bottesfoin01", file: "BottesFoin01.png", x: 679, y: 69, visible: ["C.3.1"] },
  { id: "bottesfoin02", file: "BottesFoin02.png", x: 224, y: 229, visible: ["C.3.1"] },
  { id: "tracteur", file: "Tracteur.png", x: 624, y: 577, visible: ["G.1.1"] },
]



function GameBackground() {
  let [dimensions, setDimensions] = useState(null)

  let markers = MarkersPool.all

  let imgRef = useCallback(node => {
    if(node && !dimensions) {
      setDimensions(calculateDimensions(node))
    }
  }, [dimensions])

  const resetDimensions = () => { setDimensions(null) }

  useEffect(() => {
    window.addEventListener('resize', resetDimensions)
    return function() {window.removeEventListener('resize', resetDimensions)}
  }, [])

  const style = {backgroundImage: `url(./images/${store.country.toLowerCase()}/background.jpg)`}

  return (
    <div
    style={style}
    className={"game-background " + (dimensions && dimensions.mode)}
    ref={imgRef} >

      {dimensions && overlays.map(o => {
          return (
            <Overlay data={o} key={o.id} dimensions={dimensions} country={store.country.toLowerCase()} />
          )
        })
      }


      { (dimensions &&
        markers.length > 0) &&
        markers.map((marker, index) => {
          return <Marker
            key={index}
            data={marker}
            dimensions={dimensions} />
        })}
    </div>
  )
}

export default observer(GameBackground)
